import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "version-admin" }
const _hoisted_2 = {
  key: 0,
  class: "form-tip",
  style: {"color":"#67c23a"}
}
const _hoisted_3 = {
  key: 1,
  class: "form-tip",
  style: {"color":"#67c23a"}
}
const _hoisted_4 = {
  key: 2,
  class: "form-tip",
  style: {"color":"#f56c6c"}
}
const _hoisted_5 = {
  key: 3,
  class: "form-tip"
}
const _hoisted_6 = { class: "el-upload__tip" }
const _hoisted_7 = { class: "card-header" }

import { ref, reactive, computed, onMounted, watch } from 'vue'
import { UploadFilled, Loading } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import AppVersionAdminApi from '@/network/apis/AppVersionAdmin'
import { parseApkVersion } from '@/utils/apkParser'
import type { ApkVersionInfo } from '@/utils/apkParser'
import { parseHapVersion } from '@/utils/hapParser'
import type { HapVersionInfo } from '@/utils/hapParser'
import { useButtonPermission } from '@/utils/buttonPermission'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { can } = useButtonPermission('/KaiFa/AppVersionAdmin/index.vue')

const formRef = ref()
const uploadRef = ref()
const form = reactive({
  type: '安卓',
  version: '',
  remarks: '',
  file: null as File | null
})

const isWindows = computed(() => form.type === 'windows')
const isAndroid = computed(() => form.type === '安卓')
const isHarmony = computed(() => form.type === '鸿蒙')

const rules = {
  type: [{ required: true, message: '请选择平台', trigger: 'change' }],
  version: [
    {
      validator: (_rule: any, value: string, callback: (error?: Error) => void) => {
        if (isWindows.value) {
          callback()
          return
        }
        if (!value) {
          callback(new Error('请输入版本号'))
          return
        }
        if (!/^\d+(\.\d+)*$/.test(value)) {
          callback(new Error('格式如 1.4 或 1.3.34'))
          return
        }
        callback()
      },
      trigger: 'blur'
    }
  ],
  remarks: [{ required: true, message: '请输入更新说明', trigger: 'blur' }]
}

const uploadAccept = computed(() => {
  if (form.type === '安卓') return '.apk'
  if (form.type === 'windows') return '.exe,.msi,.zip'
  return '.hap'
})

const acceptTip = computed(() => {
  if (form.type === '安卓') return '支持 .apk 文件'
  if (form.type === 'windows') return '支持 .exe / .msi / .zip 文件'
  return '支持 .hap 文件'
})

const versionLabel = computed(() => isWindows.value ? '版本号（选填）' : '版本号')

const versionPlaceholder = computed(() => {
  if (isAndroid.value) {
    return parsing.value ? '正在解析 APK...' : '如 1.4 或 1.3.34'
  }
  if (isWindows.value) {
    return '可不填，如需填写可输入 1.4 或 1.3.34'
  }
  if (isHarmony.value) {
    return parsing.value ? '正在解析 HAP...' : '上传 HAP 后自动填充 versionCode'
  }
  return '如 1.4 或 1.3.34'
})

const versionTip = computed(() => {
  if (isAndroid.value) return '选择 APK 文件后自动解析版本号'
  if (isWindows.value) return 'Windows 版本上传无需输入版本号'
  if (isHarmony.value) return '选择 HAP 文件后自动解析 versionCode'
  return '请输入版本号'
})

const platformTagType = (type: string) => {
  if (type === '安卓') return 'success'
  if (type === '鸿蒙') return 'warning'
  if (type === 'windows') return '' as const
  return 'info'
}

const uploading = ref(false)
const uploadProgress = ref(0)
const parsing = ref(false)
const parsedInfo = ref<ApkVersionInfo | null>(null)
const parsedHapInfo = ref<HapVersionInfo | null>(null)
const parseError = ref('')

const clearUploadState = () => {
  uploadRef.value?.clearFiles()
  form.file = null
  parsedInfo.value = null
  parsedHapInfo.value = null
  parseError.value = ''
  parsing.value = false
}

watch(() => form.type, () => {
  clearUploadState()
  form.version = ''
  loadVersionList()
})

const isApkFile = (file: File) => file.name.toLowerCase().endsWith('.apk')
const isHapFile = (file: File) => file.name.toLowerCase().endsWith('.hap')

const handleFileChange = async (uploadFile: any) => {
  const rawFile = uploadFile.raw as File
  if (!rawFile) {
    return
  }

  if (isAndroid.value && !isApkFile(rawFile)) {
    ElMessage.warning('安卓版本仅支持上传 .apk 格式文件')
    clearUploadState()
    return
  }

  if (isHarmony.value && !isHapFile(rawFile)) {
    ElMessage.warning('鸿蒙版本仅支持上传 .hap 格式文件')
    clearUploadState()
    return
  }

  form.file = uploadFile.raw
  parsedInfo.value = null
  parsedHapInfo.value = null
  parseError.value = ''

  if (form.file && form.file.name.toLowerCase().endsWith('.apk')) {
    parsing.value = true
    try {
      const info = await parseApkVersion(form.file)
      parsedInfo.value = info
      if (info.versionName) {
        form.version = info.versionName
      }
    } catch (err) {
      console.error('APK 解析失败:', err)
      parseError.value = 'APK 版本解析失败'
    } finally {
      parsing.value = false
    }
    return
  }

  if (form.file && isHarmony.value && isHapFile(form.file)) {
    parsing.value = true
    try {
      const info = await parseHapVersion(form.file)
      parsedHapInfo.value = info
      form.version = info.versionCode
    } catch (err) {
      console.error('HAP 解析失败:', err)
      parseError.value = 'HAP 版本解析失败'
    } finally {
      parsing.value = false
    }
  }
}

const handleFileRemove = () => {
  form.file = null
  parsedInfo.value = null
  parsedHapInfo.value = null
  parseError.value = ''
}

const handlePublish = async () => {
  try {
    await formRef.value.validate()
  } catch {
    return
  }

  if (!form.file) {
    ElMessage.warning('请选择安装包文件')
    return
  }

  if (isAndroid.value && !isApkFile(form.file)) {
    ElMessage.warning('安卓版本仅支持上传 .apk 格式文件')
    return
  }

  if (isHarmony.value && !isHapFile(form.file)) {
    ElMessage.warning('鸿蒙版本仅支持上传 .hap 格式文件')
    return
  }

  uploading.value = true
  uploadProgress.value = 0

  try {
    const res = await AppVersionAdminApi.uploadPackage(
      form.file,
      { version: form.version, type: form.type, remarks: form.remarks },
      (percent: number) => { uploadProgress.value = percent }
    )
    if (res && res.status === 200) {
      ElMessage.success(res.msg || '上传成功')
    } else {
      ElMessage.success('上传成功')
    }
    handleReset()
    loadVersionList()
  } catch (err: any) {
    const msg = err?.response?.data?.msg || err?.response?.data?.message || '上传失败，请检查网络或后端服务'
    ElMessage.error(msg)
  } finally {
    uploading.value = false
  }
}

const handleReset = () => {
  const currentType = form.type
  formRef.value?.resetFields()
  form.type = currentType
  clearUploadState()
  uploadProgress.value = 0
}

const versionList = ref<any[]>([])
const listLoading = ref(false)

const buildVersionListFilters = () => ([
  {
    FieldName: '类型',
    FiedType: 'string',
    Type: 3,
    Value1: form.type,
    Value2: ''
  }
])

const loadVersionList = async () => {
  listLoading.value = true
  try {
    const res: any = await AppVersionAdminApi.getVersionList({}, buildVersionListFilters())
    const respData = res?.response || res
    const list = respData?.data || respData || []
    versionList.value = Array.isArray(list) ? list : []
  } catch (err) {
    console.error('获取版本列表失败:', err)
  } finally {
    listLoading.value = false
  }
}

const handleCopyUrl = (row: any) => {
  const fileName = row['文件名']
  if (!fileName) {
    ElMessage.warning('无文件名')
    return
  }
  const url = AppVersionAdminApi.getDownloadUrl(fileName)
  navigator.clipboard.writeText(url).then(() => {
    ElMessage.success('下载链接已复制到剪贴板')
  }).catch(() => {
    const input = document.createElement('input')
    input.value = url
    document.body.appendChild(input)
    input.select()
    document.execCommand('copy')
    document.body.removeChild(input)
    ElMessage.success('下载链接已复制到剪贴板')
  })
}

onMounted(() => {
  loadVersionList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(can)('上传'))
      ? (_openBlock(), _createBlock(_component_el_card, {
          key: 0,
          shadow: "hover",
          class: "publish-card"
        }, {
          header: _withCtx(() => _cache[3] || (_cache[3] = [
            _createElementVNode("div", { class: "card-header" }, [
              _createElementVNode("span", null, "发布新版本")
            ], -1)
          ])),
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref_key: "formRef",
              ref: formRef,
              model: form,
              rules: rules,
              "label-width": "120px",
              "label-position": "right"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "平台类型",
                  prop: "type"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: form.type,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.type) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio, { value: "安卓" }, {
                          default: _withCtx(() => _cache[4] || (_cache[4] = [
                            _createTextVNode("安卓")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_el_radio, { value: "鸿蒙" }, {
                          default: _withCtx(() => _cache[5] || (_cache[5] = [
                            _createTextVNode("鸿蒙")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_el_radio, { value: "windows" }, {
                          default: _withCtx(() => _cache[6] || (_cache[6] = [
                            _createTextVNode("Windows")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (!isWindows.value)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: versionLabel.value,
                      prop: "version"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: form.version,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.version) = $event)),
                          placeholder: versionPlaceholder.value,
                          disabled: parsing.value,
                          style: {"max-width":"260px"}
                        }, {
                          suffix: _withCtx(() => [
                            (parsing.value)
                              ? (_openBlock(), _createBlock(_component_el_icon, {
                                  key: 0,
                                  class: "is-loading"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Loading))
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder", "disabled"]),
                        (isAndroid.value && parsedInfo.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_2, " 已从 APK 解析: versionName=" + _toDisplayString(parsedInfo.value.versionName) + ", versionCode=" + _toDisplayString(parsedInfo.value.versionCode), 1))
                          : (isHarmony.value && parsedHapInfo.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_3, " 已从 " + _toDisplayString(parsedHapInfo.value.source) + " 解析: versionCode=" + _toDisplayString(parsedHapInfo.value.versionCode), 1))
                            : ((isAndroid.value || isHarmony.value) && parseError.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(parseError.value) + "（请手动输入版本号） ", 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(versionTip.value), 1))
                      ]),
                      _: 1
                    }, 8, ["label"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, {
                  label: "说明",
                  prop: "remarks"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: form.remarks,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.remarks) = $event)),
                      type: "textarea",
                      rows: 4,
                      placeholder: "1. 修复xx问题\n2. 新增xx功能",
                      style: {"max-width":"500px"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "安装包文件" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_upload, {
                      ref_key: "uploadRef",
                      ref: uploadRef,
                      "auto-upload": false,
                      limit: 1,
                      "on-change": handleFileChange,
                      "on-remove": handleFileRemove,
                      accept: uploadAccept.value,
                      drag: "",
                      style: {"max-width":"500px"}
                    }, {
                      tip: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, _toDisplayString(acceptTip.value) + "，单个文件不超过 200MB ", 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, { style: {"font-size":"40px","color":"#909399","margin-bottom":"8px"} }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(UploadFilled))
                          ]),
                          _: 1
                        }),
                        _cache[7] || (_cache[7] = _createElementVNode("div", null, [
                          _createTextVNode("将安装包拖拽到此处，或 "),
                          _createElementVNode("em", null, "点击选择文件")
                        ], -1))
                      ]),
                      _: 1
                    }, 8, ["accept"])
                  ]),
                  _: 1
                }),
                (uploading.value)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      label: "上传进度"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_progress, {
                          percentage: uploadProgress.value,
                          status: uploadProgress.value >= 100 ? 'success' : '',
                          style: {"max-width":"500px"}
                        }, null, 8, ["percentage", "status"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "large",
                      loading: uploading.value,
                      onClick: handlePublish
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(uploading.value ? '上传中...' : '发布版本'), 1)
                      ]),
                      _: 1
                    }, 8, ["loading"]),
                    _createVNode(_component_el_button, {
                      size: "large",
                      onClick: handleReset
                    }, {
                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                        _createTextVNode("重置")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_card, {
      shadow: "hover",
      class: "list-card"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _cache[10] || (_cache[10] = _createElementVNode("span", null, "已发布版本", -1)),
          _createVNode(_component_el_button, {
            type: "primary",
            text: "",
            onClick: loadVersionList
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createTextVNode("刷新")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: versionList.value,
          stripe: "",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "版本号",
              label: "版本号",
              width: "120"
            }),
            _createVNode(_component_el_table_column, {
              prop: "类型",
              label: "平台",
              width: "100"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_tag, {
                  type: platformTagType(row['类型'])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row['类型']), 1)
                  ]),
                  _: 2
                }, 1032, ["type"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "文件名",
              label: "文件名",
              width: "180"
            }),
            _createVNode(_component_el_table_column, {
              prop: "说明",
              label: "说明",
              "min-width": "200",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "上传人",
              label: "上传人",
              width: "120"
            }),
            _createVNode(_component_el_table_column, {
              prop: "上传日期",
              label: "上传时间",
              width: "180"
            }),
            (_unref(can)('下载'))
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  label: "操作",
                  width: "140",
                  fixed: "right"
                }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      link: "",
                      size: "small",
                      onClick: ($event: any) => (handleCopyUrl(row))
                    }, {
                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createTextVNode(" 复制下载链接 ")
                      ])),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, listLoading.value]
        ])
      ]),
      _: 1
    })
  ]))
}
}

})